import { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "../../newstyle.css";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "../../../../Components/SearchBox";
import { Formik } from "formik";

import { useQuery } from "@tanstack/react-query";
import {
  ProductVariationSearchBarInitialValues,
} from "../../constant";
import {
  Confirmation,
  ErrorToast,
  SuccessToast,
} from "../../../../Utils/SweetAlert";
import {
  useMutateDeleteUserVariations,
} from "../../hooks/useApiHook";
import Pagination from "../../../../Utils";
import { GetProductVariationsList } from "../../../../Api/productVariations";
import { EditButton, DeleteButton } from "../../../../Components";
import AddButton from "../../../../Components/AddButton";

const ProductVariationsList = () => {
  const navigate = useNavigate();
  const formRef = useRef();

  const deleteUserVariations = useMutateDeleteUserVariations();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const {
    isFetching: isProductVariationsLoading,
    data: productVariationsList,
    refetch,
  } = useQuery({
    queryKey: ["get-product-variations-list", page, limit],
    queryFn: () =>
      GetProductVariationsList({
        limit: limit,
        page: page === 0 ? 1 : page + 1,
        search: formRef?.current?.values?.search,
      }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
  };

  const handleLimitChange = async (event) => {
    setPage(0);
    setLimit(parseInt(event.target.value, 10));
  };


  return (
    <>
      <Helmet>
        <title>OVE | Admin Product Variation </title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="admin-wrapper">
            <div className="page-header">
              <div className="col">
                <h1 className="page-title">Product Variation</h1>
              </div>
              <div className="col-12 col-md-3 col-lg-2 px-2">
                <Formik
                  initialValues={ProductVariationSearchBarInitialValues}
                  innerRef={formRef}
                >
                  {() => {
                    return (
                      <form>
                        <SearchBox refetch={refetch} setPage={setPage} />
                      </form>
                    );
                  }}
                </Formik>
              </div>
              <div>
                <AddButton
                  to="/admin/add-product-variations"
                  permission="create-product-variation"
                />
              </div>
            </div>
            <div className="col-sm-12 table-width">
              <div className="cards-table card-table">
                <div className="card-body">
                  <div className="table-responsive custom-pagination">
                    <table className="table table<img<image-hover datatable table-manager">
                      <thead className="thead-light pvar-table">
                        <tr>
                          <th>Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isProductVariationsLoading && (
                          <tr>
                            <td align="center" colSpan={2}>
                              <div className="d-flex justify-content-center align-items-center py-4">
                                <div className="spinner-border loader-theme" role="status" />
                              </div>
                            </td>
                          </tr>
                        )}
                        {!isProductVariationsLoading &&
                          productVariationsList !== undefined && (
                            <>
                              {productVariationsList?.data?.data.map(
                                (item, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      className="table disable-row"
                                    >
                                      <td className="">{item?.name || "-"}</td>

                                      <td className="user-stickey-actions-body ">
                                        <EditButton
                                          to="/admin/edit-product-variations"
                                          state={{ id: item?._id }}
                                          permission="edit-product-variation"
                                        />
                                        <DeleteButton
                                          onDelete={() => {
                                            Confirmation("Are you sure you want to delete product variation?").then(
                                              async (deleteConfirm) => {
                                                if (deleteConfirm.isConfirmed) {
                                                  deleteUserVariations.mutate(item?._id, {
                                                    onSuccess: (response) => {
                                                      SuccessToast(response?.message || "Delete Successful.");
                                                      refetch();
                                                    },
                                                    onError: (error) => {
                                                      ErrorToast(error?.response?.data?.message || "Server Error.");
                                                    },
                                                  });
                                                }
                                              }
                                            );
                                          }}
                                          permission="delete-product-variation"
                                        />
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                              {productVariationsList?.data?.data?.length ===
                                0 && (
                                  <tr>
                                    <td className="text-center" colSpan={8}>
                                      No Records Found.
                                    </td>
                                  </tr>
                                )}
                            </>
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <Pagination
              totalItem={productVariationsList?.data?.totalRecords || 0}
              itemsPerPage={limit}
              page={
                !productVariationsList?.data?.totalRecords ||
                  productVariationsList?.data?.totalRecords <= 0
                  ? 0
                  : page
              }
              handleChangePage={handlePageChange}
              handleChangeRowsPerPage={handleLimitChange}
              colSpan={6}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductVariationsList;
